import { createContext, type ReactNode, useContext, useState } from "react";

type Slot = [HTMLElement | null, (el: HTMLElement | null) => void];

const ModuleActionsSlotContext = createContext<Slot | null>(null);

/**
 * Lets a page put its main buttons in the module header, on the line of the module's icon and name.
 * Wrap the ModuleHeader and the page content in it; PageHead with `titleHidden` moves its actions there.
 */
export function ModuleActionsProvider({ children }: { children: ReactNode }): React.JSX.Element {
  const slot = useState<HTMLElement | null>(null);
  return <ModuleActionsSlotContext.Provider value={slot}>{children}</ModuleActionsSlotContext.Provider>;
}

/** The header's spot for the page buttons (null when no module header is showing). */
export function useModuleActionsSlot(): Slot | null {
  return useContext(ModuleActionsSlotContext);
}
